import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal } from '@cancercentrum/rcc-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTrashAlt, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
export const DeleteModal = (props)=>{
    const { onCancel, onSuccess } = props;
    return /*#__PURE__*/ _jsxs(Modal, {
        show: true,
        onHide: onCancel,
        backdrop: "static",
        bsSize: "xl",
        animation: false,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                children: /*#__PURE__*/ _jsxs(Modal.Title, {
                    children: [
                        /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                            icon: faExclamationTriangle,
                            style: {
                                color: 'orange'
                            }
                        }),
                        " Radera ärendet?"
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: "Vill du verkligen radera ärendet? Åtgärd går inte att ångra."
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        icon: faTimes,
                        onClick: onCancel,
                        bsStyle: "default-2",
                        children: "Nej, avbryt"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        icon: faTrashAlt,
                        bsStyle: "danger",
                        className: "mr-2",
                        onClick: ()=>onSuccess(),
                        children: "Ja, radera ärende"
                    })
                ]
            })
        ]
    });
};
